import { useState } from "react";
import { Send } from "lucide-react";
import { waLink } from "./data";
import { trackLeadFormSubmit } from "../../lib/analytics";

const API = process.env.REACT_APP_BACKEND_URL;

export default function LeadForm({ idPrefix = "lead-form", title, subtitle, source = "web" }) {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [proto, setProto] = useState("Prototipo B · 101.09 m²");
  const [date, setDate] = useState("");

  const submit = (e) => {
    e.preventDefault();
    const msg = `Hola, soy ${name || "un interesado"} (${phone || "sin teléfono"}). Me interesa ${proto} de Condominio EHÉCATL. Quiero agendar una visita${date ? ` el ${date}` : ""} y recibir una cotización.`;
    if (API) {
      fetch(`${API}/api/leads`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, phone, prototype: proto, preferred_date: date, source }),
      }).catch(() => {});
    }
    trackLeadFormSubmit({ content_name: source, prototipo: proto });
    window.open(waLink(msg), "_blank");
  };

  const inputCls =
    "mt-2 w-full rounded-lg border border-white/10 bg-[#1c242f] px-4 py-3.5 text-sm text-[#f4f2ea] placeholder:text-[#5f6459] focus:outline-none focus:border-[#bfa360]/60 transition-colors";
  const labelCls = "mono text-[10px] uppercase tracking-[0.22em] text-[#bfa360]";

  return (
    <form
      data-testid={`${idPrefix}-form`}
      onSubmit={submit}
      className="rounded-2xl border border-white/10 bg-[#222e3b]/80 backdrop-blur-xl p-6 sm:p-9 shadow-2xl"
    >
      <h3 className="font-display text-2xl sm:text-3xl text-[#f4f2ea] mb-2">{title}</h3>
      <p className="text-sm text-[#a8ac9b] mb-7">{subtitle}</p>

      <label className="block mb-4">
        <span className={labelCls}>Nombre</span>
        <input
          data-testid={`${idPrefix}-name`}
          type="text"
          required
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Tu nombre"
          className={inputCls}
        />
      </label>
      <label className="block mb-4">
        <span className={labelCls}>WhatsApp</span>
        <input
          data-testid={`${idPrefix}-phone`}
          type="tel"
          required
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="55 0000 0000"
          className={inputCls}
        />
      </label>
      <div className="grid sm:grid-cols-2 gap-4 mb-7">
        <label className="block">
          <span className={labelCls}>Me interesa</span>
          <select
            data-testid={`${idPrefix}-prototype`}
            value={proto}
            onChange={(e) => setProto(e.target.value)}
            className={inputCls}
          >
            <option>Prototipo A · 86.40 m²</option>
            <option>Prototipo B · 101.09 m²</option>
            <option>Aún no lo sé, quiero asesoría</option>
          </select>
        </label>
        <label className="block">
          <span className={labelCls}>Fecha de visita</span>
          <input
            data-testid={`${idPrefix}-date`}
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            min={new Date().toISOString().split("T")[0]}
            className={`${inputCls} [color-scheme:dark]`}
          />
        </label>
      </div>

      <button
        data-testid={`${idPrefix}-submit`}
        type="submit"
        className="w-full inline-flex items-center justify-center gap-3 rounded-full bg-[#25D366] px-8 py-4 text-sm font-bold text-[#062b16] hover:brightness-110 transition"
      >
        <Send size={16} />
        Enviar y abrir WhatsApp
      </button>
      <p className="mt-5 flex items-center justify-center gap-2.5 mono text-[10px] sm:text-[11px] uppercase tracking-[0.2em] text-[#ddc68c]">
        <span className="h-2 w-2 rounded-full bg-[#25D366] animate-pulse" />
        Sin compromiso · Respuesta el mismo día
      </p>
    </form>
  );
}
